import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  Chip,
} from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodesProps {
  tests: Array<{
    RegistrationTestId: string;
    TestName?: string;
    sampleId?: string;
    qrCode?: string;
  }>;
}

export const QRCodes: React.FC<QRCodesProps> = ({ tests }) => {
  return (
    <Grid container spacing={2}>
      {tests.map((test) => (
        <Grid size={{ xs: 6, sm: 4 }} key={test.RegistrationTestId}>
          <Paper
            elevation={2}
            sx={{
              p: 1.5,
              textAlign: 'center',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            {test.qrCode ? (
              <img src={test.qrCode} alt={`QR for ${test.TestName}`} style={{ width: 100, height: 100 }} />
            ) : (
              <QRCodeSVG value={test.sampleId || test.RegistrationTestId} size={100} />
            )}
            <Typography variant="caption" display="block" sx={{ mt: 1, fontWeight: 'bold' }}>
              {test.TestName || 'Test'}
            </Typography>
            <Chip
              label={test.sampleId || test.RegistrationTestId}
              size="small"
              variant="outlined"
              sx={{ mt: 1, fontSize: '0.6rem' }}
            />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

// import React from 'react';
// import {
//   Grid,
//   Paper,
//   Typography,
//   Chip,
// } from '@mui/material';
// import { QRCodeSVG } from 'qrcode.react';

// interface QRCodesProps {
//   tests: Array<{
//     id: number;
//     testCode: string;
//     testName: string;
//     sampleId: string;
//     qrCode: string;
//   }>;
// }

// export const QRCodes: React.FC<QRCodesProps> = ({ tests }) => {
//   return (
//     <Grid container spacing={2}>
//       {tests.map((test) => (
//         <Grid size={{ xs: 6, sm: 4 }} key={test.id}>
//           <Paper
//             elevation={2}
//             sx={{
//               p: 1.5,
//               textAlign: 'center',
//               transition: 'transform 0.2s',
//               '&:hover': {
//                 transform: 'scale(1.05)',
//               },
//             }}
//           >
//             <QRCodeSVG value={test.sampleId} size={100} />
//             <Typography variant="caption" display="block" sx={{ mt: 1, fontWeight: 'bold' }}>
//               {test.testName}
//             </Typography>
//             <Typography variant="caption" color="textSecondary" display="block">
//               {test.testCode}
//             </Typography>
//             <Chip
//               label={test.sampleId}
//               size="small"
//               variant="outlined"
//               sx={{ mt: 1, fontSize: '0.6rem' }}
//             />
//           </Paper>
//         </Grid>
//       ))}
//     </Grid>
//   );
// };